import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";
import ChangePassword from "../../components/user/ChangePassword/ChangePassword";

export default class ChangePasswordPage extends Component {
  render() {
    return (
      <div>
        <MyNavbar />
        <ChangePassword />
      </div>
    );
  }
}
